require('../../../libs/backbone/backbone.ajaxq.adapter.ts');

var GenericView = require('../generic.view.ts');
var Handlebars = require('handlebars');

var PreparationPopupTemplate = require('text-loader!../../templates/counter/preparationPopup.template.html');

var i18n = require("l10n");

require('../../../libs/bootstrap/js/bootstrap-table.js');
require('jqueryUI');


var TheView = GenericView.extend({
    el: "#preparationPopup",
    tagName: 'div',
	template: Handlebars.compile(PreparationPopupTemplate),
	popupData: {
	    venue: null,
    	queue: null,
    	ticket: null,
	},
	submitCallback: null,
	initialize: function(options) {
		var self = this;

        this.submitCallback = options ? options.submitCallback : null;
        this.callerView = options ? options.view : null;

        this.render({
            'ticketNum': -1,
            'fullCustomerName': i18n.t("counter.noCustomerName"),
            'customerCode': '-'
        });
	},
	superRender:  GenericView.prototype.render,
	render: function (templateData) {
		this.superRender();

		this.$el.html( this.template(templateData) );
	},
	events: {
        "click #closePreparationPopup": "closePreparationPopup",
        "click #submitPreparation": "submitPreparationPopup",
	},
	submitPreparationPopup: function(evt) {
	    var self = this;
	    var minutes = parseInt(this.$el.find("#preparationMinutes").val());

        var $elem = $(evt.currentTarget);

        if(minutes == null || minutes == "" || isNaN(minutes) || parseInt(minutes) <= 0 || (parseFloat(minutes) % 1 != 0)) {

            var text = i18n.t("queue.nonNumericValue");

            if(parseInt(value) <= 0)
                text = i18n.t("queue.valueMoreThan", {value: 0})

            $elem.notify(text,
            {
                position:"top center",
                className: "error",
                autoHide: true
            });

            return;
        }

        var preparation = {
            "preparationId": null,
            "queueId": self.popupData.queue.queueId,
            "firstName": self.popupData.ticket.customerFirstName,
            "lastName": self.popupData.ticket.customerLastName,
            "customerId": self.popupData.ticket.customerId,
            //"status": false,
            //"date": new Date().getTime(),
            "minutes": minutes
        }

        $.ajaxDefaultQ({
            url: "rest/api/preparations",
            type: "POST",
            contentType: "application/json",
            data: JSON.stringify(preparation)

        }).done(function(response, status, xhr){

            if(response != null) {

                var text = "";
                var className = "";

                if(response.data == "AlreadyInList") {
                    text = i18n.t("counter.alreadyInPreparationList");
                    className = "info";
                }
                else if(response.data == "QueueClosed") {
                    text = i18n.t("counter.preparationOnClosedQueue");
                    className = "warning";
                }
                else {
                    text = i18n.t("counter.addedPreparationSuccessfully");
                    className = "success";

                    if(self.submitCallback)
                        self.submitCallback(self.callerView);
                }

                $elem.notify(text,
                {
                    position: "top center",
                    className: className,
                    autoHide: true
                });

                if(className == "success")
                    self.closePreparationPopup();

            }
            else {
                $elem.notify(i18n.t("server.errorOccurred"),
                {
                    position:"top center",
                    className: "error",
                    autoHide: true
                });

            }

        })
        .fail(function(response) {
            $elem.notify(i18n.t("server.errorOccurred"),
            {
                position: "top center",
                className: "error",
                autoHide: true
            });

        });
	},
	closePreparationPopup: function() {
	    var $popupEl = this.$el;
        if($popupEl.hasClass('shown-preparation-popup'))
            $popupEl.removeClass('shown-preparation-popup');
	},
	setData: function(data) {
        this.popupData.venue = data ? data.venue : null;
        this.popupData.queue = data ? data.queue : null;
        this.popupData.ticket = data ? data.ticket : null;
	},
	show: function() {
        var self = this;

        var $popupEl = this.$el;

        if($popupEl.hasClass('shown-preparation-popup')) {
            $popupEl.removeClass('shown-preparation-popup');
            return;
        }

        var ticketNum = "#" + this.popupData.ticket.displayNumber;
        var fullCustomerName = Handlebars.helpers.customerNameOrEmpty(this.popupData.ticket.customerFirstName, this.popupData.ticket.customerLastName);
        var customerCode = this.popupData.ticket.displayNumber;

        var customerAndTicketData = {
            "ticketNum": ticketNum,
            "fullCustomerName": fullCustomerName,
            "customerCode": customerCode
        };

        $popupEl.find("#popupCustomerInfo").text( `${ticketNum} ${fullCustomerName} ${customerCode}` );

        if(!$popupEl.hasClass('shown-preparation-popup'))
            $popupEl.addClass('shown-preparation-popup');
    },
    hide: function() {
        var $popupEl = this.$el;
        if($popupEl.hasClass('shown-preparation-popup'))
            $popupEl.removeClass('shown-preparation-popup');
    }

});

module.exports = TheView;